// Please do not use this in any other place than public Campaign Plan page
// To be removed once BE serves localeCode for the non-authenticated app with a separate service or in the response

export const publicDefaultLocaleCodes: Record<string, string> = {
  AE: 'ar-AE',
  AF: 'fa-AF',
  AL: 'sq-AL',
  AM: 'hy-AM',
  AO: 'pt-AO',
  AR: 'es-AR',
  AT: 'de-AT',
  AU: 'en-AU',
  AZ: 'az-AZ',
  BA: 'bs-BA',
  BD: 'bn-BD',
  BE: 'nl-BE',
  BG: 'bg-BG',
  BH: 'ar-BH',
  BJ: 'fr-BJ',
  BN: 'ms-BN',
  BO: 'es-BO',
  BR: 'pt-BR',
  BS: 'en-BS',
  BT: 'dz-BT',
  BW: 'en-BW',
  BY: 'be-BY',
  BZ: 'en-BZ',
  CA: 'en-CA',
  CD: 'fr-CD',
  CF: 'fr-CF',
  CG: 'fr-CG',
  CH: 'de-CH',
  CI: 'fr-CI',
  CL: 'es-CL',
  CM: 'fr-CM',
  CN: 'zh-CN',
  CO: 'es-CO',
  CR: 'es-CR',
  CU: 'es-CU',
  CY: 'el-CY',
  CZ: 'cs-CZ',
  DE: 'de-DE',
  DK: 'da-DK',
  DO: 'es-DO',
  DZ: 'ar-DZ',
  EC: 'es-EC',
  EE: 'et-EE',
  EG: 'ar-EG',
  ES: 'es-ES',
  ET: 'am-ET',
  FI: 'fi-FI',
  FJ: 'en-FJ',
  FR: 'fr-FR',
  GA: 'fr-GA',
  GB: 'en-GB',
  GE: 'ka-GE',
  GH: 'en-GH',
  GM: 'en-GM',
  GN: 'fr-GN',
  GQ: 'es-GQ',
  GR: 'el-GR',
  GT: 'es-GT',
  GW: 'pt-GW',
  GY: 'en-GY',
  HN: 'es-HN',
  HR: 'hr-HR',
  HT: 'fr-HT',
  HU: 'hu-HU',
  ID: 'id-ID',
  IE: 'en-IE',
  IL: 'he-IL',
  IN: 'hi-IN',
  IQ: 'ar-IQ',
  IR: 'fa-IR',
  IS: 'is-IS',
  IT: 'it-IT',
  JM: 'en-JM',
  JO: 'ar-JO',
  JP: 'ja-JP',
  KE: 'en-KE',
  KG: 'ky-KG',
  KH: 'km-KH',
  KM: 'ar-KM',
  KN: 'en-KN',
  KP: 'ko-KP',
  KR: 'ko-KR',
  KW: 'ar-KW',
  KZ: 'kk-KZ',
  LA: 'lo-LA',
  LB: 'ar-LB',
  LC: 'en-LC',
  LI: 'de-LI',
  LK: 'si-LK',
  LR: 'en-LR',
  LS: 'en-LS',
  LT: 'lt-LT',
  LU: 'fr-LU',
  LV: 'lv-LV',
  LY: 'ar-LY',
  MA: 'ar-MA',
  MC: 'fr-MC',
  MD: 'ro-MD',
  ME: 'sr-ME',
  MG: 'fr-MG',
  MK: 'mk-MK',
  ML: 'fr-ML',
  MM: 'my-MM',
  MN: 'mn-MN',
  MR: 'ar-MR',
  MT: 'mt-MT',
  MU: 'en-MU',
  MV: 'dv-MV',
  MW: 'en-MW',
  MX: 'es-MX',
  MY: 'ms-MY',
  MZ: 'pt-MZ',
  NA: 'en-NA',
  NE: 'fr-NE',
  NG: 'en-NG',
  NI: 'es-NI',
  NL: 'nl-NL',
  NO: 'nb-NO',
  NP: 'ne-NP',
  NR: 'en-NR',
  NZ: 'en-NZ',
  OM: 'ar-OM',
  PA: 'es-PA',
  PE: 'es-PE',
  PG: 'en-PG',
  PH: 'en-PH',
  PK: 'ur-PK',
  PL: 'pl-PL',
  PT: 'pt-PT',
  PY: 'es-PY',
  QA: 'ar-QA',
  RO: 'ro-RO',
  RS: 'sr-RS',
  RU: 'ru-RU',
  RW: 'rw-RW',
  SA: 'ar-SA',
  SC: 'fr-SC',
  SD: 'ar-SD',
  SE: 'sv-SE',
  SG: 'en-SG',
  SI: 'sl-SI',
  SK: 'sk-SK',
  SL: 'en-SL',
  SM: 'it-SM',
  SN: 'fr-SN',
  SO: 'so-SO',
  SR: 'nl-SR',
  ST: 'pt-ST',
  SV: 'es-SV',
  SY: 'ar-SY',
  SZ: 'en-SZ',
  TD: 'fr-TD',
  TG: 'fr-TG',
  TH: 'th-TH',
  TJ: 'tg-TJ',
  TL: 'pt-TL',
  TM: 'tk-TM',
  TN: 'ar-TN',
  TO: 'en-TO',
  TR: 'tr-TR',
  TT: 'en-TT',
  TW: 'zh-TW',
  TZ: 'sw-TZ',
  UA: 'uk-UA',
  UG: 'en-UG',
  US: 'en-US',
  UY: 'es-UY',
  UZ: 'uz-UZ',
  VA: 'it-VA',
  VC: 'en-VC',
  VE: 'es-VE',
  VN: 'vi-VN',
  WS: 'sm-WS',
  XK: 'sq-XK',
  YE: 'ar-YE',
  ZA: 'en-ZA',
  ZM: 'en-ZM',
  ZW: 'en-ZW',
};
